export default __webpack_public_path__ + "static/do-bg-4ca037ebc0217ccb75885c3779703dfa.png";